export const BaseUrl={
    fetchUrl:
        process.env.NODE_ENV==="production"?'https://api.discoverphl.top':
        process.env.NODE_ENV==="prod"?'https://api.discoverphl.top':
        process.env.NODE_ENV==="development"?'https://api.discoverphl.top':''
}
